module.exports = "/_next/static/images/game-1-phone-wallpaper-36d9db202b854d343c6f4000e30ea594.jpg";